import { getBaseUrl } from './base-url';
import {
    BaseSiteRouterManager,
    formatUrlSuffix,
    getSiteRouterConfig,
    isValidAbsoluteUrl,
    getApiUrl,
    SiteRouterKey
} from '@libs/shared';
import { globalState } from '../../models';

class SiteRouterManager extends BaseSiteRouterManager<string> {
    protected get basePath() {
        // 注意：此处返回的baseUrl不一定是二级路径，也可能是站点+二级路径
        return getBaseUrl();
    }

    protected get router() {
        return getSiteRouterConfig();
    }

    /**
     * basePath是二级路径时，返回相对路径（二级路径+路由）
     * basePath是站点+二级路径时，返回站点绝对路径（站点+二级路径+路由）
     * @param routerKey 路由 key
     * @param args 路由参数
     */
    public getPath(routerKey: SiteRouterKey, ...args: (string | number)[]) {
        return this.relativePath(routerKey, ...args);
    }

    /**
     * basePath是二级路径时，返回带参相对路径（二级路径+路由+参数）
     * basePath是站点+二级路径时，返回带参站点绝对路径（站点+二级路径+路由+参数）
     * @param query 查询参数
     * @param routerKey 路由 key
     * @param args 路由参数
     */
    public getQueryPath(
        query: { key: string; value: string | number }[],
        routerKey: SiteRouterKey,
        ...args: (string | number)[]
    ) {
        return this.queryRelativePath(query, routerKey, ...args);
    }
    // ……其他公共方法

    /**
     * 获取云币购买链接
     */
    public getPurchaseCoinLink() {
        const purchaseCoinLink = globalState.options?.links?.purchase_coin;
        if (!purchaseCoinLink) {
            return '';
        }
        if (isValidAbsoluteUrl(purchaseCoinLink)) {
            // 后台返回绝对路径时直接返回
            return purchaseCoinLink;
        }
        // 后台返回相对路径时拼接站点和二级路径后再返回
        return formatUrlSuffix(this.basePath, purchaseCoinLink);
    }

    protected relativePath(routerKey: SiteRouterKey, ...args: (string | number)[]) {
        const pattern = this.router[routerKey];
        const adminPattern = this.router[SiteRouterKey.CorpAdmin];
        const isAdminRoute = pattern === adminPattern || pattern.startsWith(`${adminPattern}#`);
        if (globalState.platformSite && isAdminRoute) {
            return formatUrlSuffix(globalState.platformSite, getApiUrl(pattern, ...args));
        }
        return super.relativePath(routerKey, ...args);
    }
}

const siteRouterManager = new SiteRouterManager();

export default siteRouterManager;
